import React from 'react';

import SvgIcon from '~/core/iconComponents/SvgIcon';
import { IconProps } from '~/core/iconComponents/types';

const DocumentContentIcon: React.FC<IconProps> = ({ className, size, disabled }) => (
  <SvgIcon
    viewBox="0 0 24 24"
    className={className}
    size={size}
    disabled={disabled}
    strokeWidth={0}
    fill="white"
    stroke="currentColor"
  >
    <path
      d="M15.4475 1.5H4.31193c-.31156 0-.56193.24522-.56193.72127V22.1247c0 .1301.25094.3753.56193.3753H19.6892c.3093 0 .5602-.2458.5602-.3753V6.36681c0-.26183-.0357-.34597-.0974-.40631l-4.4649-4.36363c-.064-.06255-.1501-.09687-.2396-.09687Z"
      fill="currentFill"
    />
    <path d="M15.6445 1.55859v4.44445h4.5453l-4.5453-4.44445Z" fill="#CDD7E0" />
    <path
      d="M9.63625 11.2484h-3.2723c-.20071 0-.36395-.1661-.36395-.3731s.16324-.3753.36395-.3753h3.2723c.20071 0 .36395.1683.36395.3753 0 .207-.16378.3731-.36395.3731Zm1.45335-.0033c-.0942 0-.1884-.0397-.2575-.1076-.0658-.0712-.107-.1684-.107-.2655 0-.0971.0407-.1959.107-.2677.1349-.1391.3816-.1391.5171 0 .0636.0718.1043.1689.1043.2677s-.0407.1943-.1043.2655c-.0696.0679-.1654.1076-.2596.1076Zm4.3653.0033h-2.9105c-.2007 0-.3618-.1661-.3618-.3731s.1611-.3753.3618-.3753h2.9105c.2007 0 .364.1683.364.3753 0 .207-.1638.3731-.364.3731Zm2.1817 0h-.7285c-.2007 0-.3639-.1661-.3639-.3731s.1638-.3753.3639-.3753h.7285c.2007 0 .3618.1683.3618.3753 0 .207-.1611.3731-.3618.3731Zm-3.2739 1.875H6.36395c-.20071 0-.36395-.1667-.36395-.3731s.16324-.3753.36395-.3753h7.99875c.2007 0 .364.1683.364.3753 0 .207-.1633.3731-.364.3731Zm3.2756 0h-2.1821c-.2007 0-.3639-.1667-.3639-.3731s.1632-.3753.3639-.3753h2.1821c.2007 0 .3618.1683.3618.3753 0 .207-.1611.3731-.3618.3731Z"
      fill="#7d97ae"
    />
  </SvgIcon>
);

export default DocumentContentIcon;
